const State = {
  userInfo: {},
  userList: [],
  productExpiredDateAlertUnreads: [],
  unreadNoticeCount: 0
}

export default State
